import React from 'react';

/** Neutral placeholder block with a soft pulse. Size and shape come from `className`. */
export default function Bone({ className = '', style }) {
    return <span aria-hidden="true" className={`block animate-pulse rounded-md bg-surface-100 ${className}`} style={style} />;
}

/** Skeleton of a `StatCard`: label + icon chip, big value and a hint line. `footer` adds metric rows. */
export function StatCardBone({ footer = false }) {
    return (
        <div className="stat-card h-full">
            <div className="flex items-start justify-between gap-3">
                <Bone className="h-3.5 w-24" />
                <Bone className="h-8 w-8 rounded-lg" />
            </div>
            <Bone className="mt-3 h-7 w-20" />
            <Bone className="mt-2.5 h-3 w-28" />
            {footer && (
                <div className="mt-4 pt-3 border-t border-surface-100 space-y-3">
                    <div className="flex items-center justify-between">
                        <Bone className="h-3.5 w-20" />
                        <Bone className="h-3.5 w-10" />
                    </div>
                    <div className="flex items-center justify-between">
                        <Bone className="h-3.5 w-16" />
                        <Bone className="h-3.5 w-10" />
                    </div>
                </div>
            )}
        </div>
    );
}

/** Skeleton of a `SectionCard` header: icon chip + title, optional action on the right. */
export function SectionHeaderBone({ action = true, titleWidth = 'w-36' }) {
    return (
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-surface-100">
            <div className="flex items-center gap-2.5">
                <Bone className="h-7 w-7" />
                <Bone className={`h-4 ${titleWidth}`} />
            </div>
            {action && <Bone className="h-6 w-20" />}
        </div>
    );
}
